import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import linkHelper from '~/helpers/link';
import $ from '~/helpers/$';
import usePortalContext from '~/contexts/portal';
import retry from '~/helpers/retry';
function handleExternalLink(href, el) {
    if (el.dataset.local === 'true') {
        // REX books open in the current window; track them
        window.location.href = href;
    }
    else {
        const newWindow = window.open(href, '_blank');
        if (newWindow === null) {
            window.location.href = href;
        }
    }
}
function isPortalRoot(portalPrefix) {
    const pathname = window.location.pathname.replace(/\/$/, '');
    return Boolean(portalPrefix && portalPrefix === pathname);
}
export default function useLinkHandler() {
    const navigate = useNavigate();
    const navigateTo = useCallback((path, state = { x: 0, y: 0 }) => {
        const stripped = linkHelper.stripOpenStaxDomain(path);
        if (stripped.startsWith('http')) {
            window.location.href = stripped;
        }
        else {
            navigate(stripped, state);
        }
    }, [navigate]);
    const { portalPrefix } = usePortalContext();
    const linkHandler = useCallback((e) => {
        // Only handle left-clicks on links
        const el = linkHelper.validUrlClick(e);
        if (!el || e.button !== 0) {
            return;
        }
        e.preventDefault();
        const fullyQualifiedHref = el.href;
        const followLink = () => {
            if (isPortalRoot(portalPrefix) || el.target || linkHelper.isExternal(fullyQualifiedHref)) {
                handleExternalLink(fullyQualifiedHref, el);
            }
            else {
                navigateTo(fullyQualifiedHref);
            }
        };
        // Pardot tracking
        if ('piTracker' in window && window.piTracker instanceof Function) {
            window.piTracker(fullyQualifiedHref.split('#')[0]);
        }
        if (e.trackingInfo) {
            retry(() => fetch(`${$.apiOriginAndOldPrefix}/salesforce/download-tracking/`, {
                method: 'POST',
                mode: 'cors',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(e.trackingInfo)
            }))
                .catch((err) => {
                console.error(`Unable to download-track: ${err}`);
            })
                .finally(followLink);
        }
        else {
            followLink();
        }
    }, [navigateTo, portalPrefix]);
    return linkHandler;
}
